<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState, mapWritableState } from 'pinia';
import { type InProgressFixture, useFixturesStore } from '@/stores/fixtures';
import Headline from '@/components/headline.vue';
import InProgress from '@/components/fixtures/in-progress.vue';
import Pagination from '@/components/pagination.vue';
import MultiDropDown from '@/components/popular/multi-drop-down.vue';
import { useSportsStore } from '@/stores/sports';

export default defineComponent({
  name: 'in-progress-fixtures-page',
  components: { MultiDropDown, Pagination, Headline, InProgressFixtures: InProgress },
  computed: {
    ...mapState(useSportsStore, ['sports']),
    ...mapState(useFixturesStore, [
      'inProgressFixturesLoading',
      'inProgressFixturesCount',
      'inProgressFixtures',
    ]),
    ...mapWritableState(useFixturesStore, [
      'inProgressFixturesOffset',
      'inProgressFixturesPageSize',
    ]),
    sportsMulti() {
      return this.sports?.map(({ value, name }) => ({
        Id: value,
        Name: name,
      }));
    }
  },
  data() {
    return {
      selectedSportIds: [] as number[],
    };
  },
  methods: {
    ...mapActions(useFixturesStore, ['fetchInProgressFixtures', 'finishFixture']),
    async finishEvent(fixture: InProgressFixture) {
      this.finishFixture(fixture).then(() => {
        this.fetchFixturesWithFilters();
      });
    },
    fetchFixturesWithFilters() {
      return this.fetchInProgressFixtures({
        sportIds: this.selectedSportIds,
      });
    },
    flipFixturesPage(newOffset: number) {
      this.inProgressFixturesOffset = newOffset;
      this.fetchFixturesWithFilters();
    },
    resizeFixturesPage(v: number) {
      this.inProgressFixturesPageSize = v;
      this.fetchFixturesWithFilters();
    }
  },
  mounted() {
    if (!this.inProgressFixtures) {
      this.fetchFixturesWithFilters();
    }
  },
  watch: {
    selectedSportIds() {
      this.fetchFixturesWithFilters();
    },
  }
});
</script>

<template>
  <teleport to="#title">
    <headline class="m-4 mt-2">
      События Live
      <template #counter>{{ inProgressFixturesCount }}</template>
    </headline>
  </teleport>
  <div
    class="grid grid-cols-[1fr_3fr_1fr_3fr_80px] gap-3 text-center"
    style="width: 100%; max-width: 100%"
  >
    <div class="place-content-center">Виды спорта</div>
    <MultiDropDown :options="sportsMulti" v-model="selectedSportIds" />
  </div>
  <InProgressFixtures
    :fixtures="inProgressFixtures"
    :finishEvent="finishEvent"
    :refresh="fetchFixturesWithFilters"
    :offset="inProgressFixturesOffset"
  />
  <div class="text-center">
    <Pagination
      :offset="inProgressFixturesOffset"
      :size="inProgressFixturesPageSize"
      :count="inProgressFixturesCount"
      :resizable="true"

      @flip="flipFixturesPage"
      @resize="resizeFixturesPage"
    />
  </div>
</template>

<style scoped lang="scss"></style>
